module.exports = __webpack_public_path__ + "img/legal-entity-profile.1403e2f4.jpg";